import { useRef } from "react";
import { useField } from "formik";
import PropTypes from "prop-types";
import { RadioIcon } from "app/icons/controls";
import "./Radio.scss";
import classNames from "classnames";
import { v4 as uuidv4 } from "uuid";

export const Radio = ({
	name,
	value,
	id: idProp,
	children,
	onChange,
	className,
	inputClassName,
	labelClassName,
	...props
}) => {
	const [field, , helpers] = useField(name);
	const generatedId = useRef(uuidv4());

	const currentValues = [].concat(field.value ?? []);
	const checked = currentValues.includes(value);

	const id = idProp || `${name}--${value}--${generatedId.current}`;

	const rootClassNames = classNames("radio-component", {
		[className]: className,
	});

	const inputClassNames = classNames("radio-component__input", {
		[inputClassName]: inputClassName,
	});

	const labelClassNames = classNames("radio-component__label", {
		[labelClassName]: labelClassName,
	});

	const handleChange = () => {
		if (onChange) {
			onChange(name, value);
		}

		helpers.setValue([value]);
	};

	return (
		<div className={rootClassNames}>
			<input
				type="radio"
				id={id}
				name={name}
				checked={checked}
				onChange={handleChange}
				onBlur={field.onBlur}
				className={inputClassNames}
				{...props}
			/>

			<label htmlFor={id} className={labelClassNames}>
				<RadioIcon checked={checked} aria-hidden={true} />

				{children}
			</label>
		</div>
	);
};

Radio.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	id: PropTypes.string,
	onChange: PropTypes.func,
	className: PropTypes.string,
	inputClassName: PropTypes.string,
	labelClassName: PropTypes.string,
};
